import { Link } from "react-router-dom";
import { CARRIER_COORDINATION as T } from "@/constants/testIds";
import { Box } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid={T.footer} className="border-t border-slate-line bg-white">
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-10">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <Link to="/carrier-coordination" className="flex items-center gap-2.5">
              <span
                className="flex h-8 w-8 items-center justify-center rounded-lg text-white shadow-card"
                style={{ backgroundColor: "hsl(var(--navy))" }}
              >
                <Box className="h-4 w-4" strokeWidth={2.4} />
              </span>
              <span className="font-semibold tracking-tight text-navy">DeMaxtore</span>
            </Link>
            <p className="mt-4 max-w-xs text-[13px] leading-relaxed text-slate-500">
              The connected Workspace for import operations, carrier coordination and export logistics.
            </p>
          </div>

          <FooterCol
            title="Workspace Products"
            links={[
              { label: "FreightIQ™", to: "/freightiq" },
              { label: "SmartContainer™", to: "/freightiq" },
              { label: "CommodityBid™", to: "/freightiq" },
              { label: "RFQ™", to: "/freightiq" },
            ]}
          />
          <FooterCol
            title="Solutions"
            links={[
              { label: "Carrier Coordination", to: "/carrier-coordination" },
              { label: "Freight Coordination", to: "/carrier-coordination" },
              { label: "Container Booking", to: "/carrier-coordination" },
              { label: "Export Logistics", to: "/carrier-coordination" },
            ]}
          />
          <FooterCol
            title="Company"
            links={[
              { label: "Create Workspace", to: "/workspace" },
              { label: "Sign in", to: "/workspace" },
              { label: "Contact", to: "/workspace" },
              { label: "Privacy", to: "/workspace" },
            ]}
          />
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-slate-line pt-6 md:flex-row md:items-center">
          <p className="text-[12px] text-slate-500">
            © {new Date().getFullYear()} DeMaxtore. FreightIQ™ is a Workspace Product of DeMaxtore.
          </p>
          <p className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
            Carrier Coordination · Booking Visibility · One Workspace
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">{title}</p>
      <ul className="mt-4 space-y-2.5">
        {links.map((l) => (
          <li key={l.label}>
            <Link to={l.to} className="text-[13.5px] text-slate-600 transition hover:text-navy">
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
